/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Overview_DescriptionInputs */

const he_dashboard_overview_description = /** @type {(inputs: Dashboard_Overview_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הכנסות חודשיות לשנה הנוכחית`)
};

const en_dashboard_overview_description = /** @type {(inputs: Dashboard_Overview_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monthly revenue for the current year`)
};

/**
* | output |
* | --- |
* | "Monthly revenue for the current year" |
*
* @param {Dashboard_Overview_DescriptionInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const dashboard_overview_description = /** @type {((inputs?: Dashboard_Overview_DescriptionInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Overview_DescriptionInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_dashboard_overview_description(inputs)
	return en_dashboard_overview_description(inputs)
});